'use client';

import Page from '@/components/pages/Page';

export default function HomePage() {
  return <Page path="/" />;
}
